import { render, staticRenderFns } from "./TTagContainer.vue?vue&type=template&id=e3665418&scoped=true&"
import script from "./TTagContainer.vue?vue&type=script&lang=js&"
export * from "./TTagContainer.vue?vue&type=script&lang=js&"
import style0 from "./TTagContainer.vue?vue&type=style&index=0&id=e3665418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3665418",
  null
  
)

/* custom blocks */
import block0 from "./TTagContainer.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports